<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มข้อมูลวัตถุดิบเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขข้อมูลวัตถุดิบเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบข้อมูลวัตถุดิบเรียบร้อย</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_show_error_max_min === true">จำนวน Max น้อยกว่า จำนวน Min และ จำนวน Min มากกว่า จำนวน Max</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_show_error_unit_other === true">หน่วยนับกับหน่วนนับอื่นต้องไม่เหมือนกัน</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_show_error_delete_stock_material === true">{{ message_error_delete_stock_material }}</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div>
            <v-row>
                <v-col cols="12">
                    <div class="text-right mb-3">
                        <v-btn height="65" width="20%" class="white--text color_stock_material_btn" @click="detailStockMaterialAdd()">
                            เพิ่มวัตถุดิบ
                        </v-btn>
                    </div>
                    <div>
                        <v-card class="pa-3">
                            <v-tabs grow v-model="page_key">
                                <v-tab @click="page(source_detail.id,index)" v-for="(source_detail,index) in source_page_list" :key="index">{{ source_detail.source_name }}</v-tab>
                            </v-tabs>

                            <div v-for="(type_list,index) in data" :key="index">
                                <v-simple-table v-if="page_id == type_list.id">
                                    <thead>
                                        <tr>
                                            <th class="text-center border_header_stock_material_list">
                                                #
                                            </th>
                                            <th class="text-center border_header_stock_material_list">
                                                รายการ
                                            </th>

                                            <th class="text-center border_header_stock_material_list">
                                                Max/Min
                                            </th>
                                            <th class="text-center border_header_stock_material_list">
                                                หน่วยนับ
                                            </th>
                                            <th class="text-center border_header_stock_material_list">
                                                จัดการ
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(typeDetail,index_type) in type_list.typeList" :key="index_type">
                                        <tr>
                                            <td colspan="7" class="primary white--text">
                                                {{ typeDetail.type_name }}
                                            </td>
                                        </tr>
                                        <tr v-for="(dataDetail,index_detail) in typeDetail.detailList" :key="index_detail">
                                            <td class="text-center border_header_stock_material_list" width="10%">{{ index_detail + 1 }}</td>
                                            <td class="text-left border_header_stock_material_list" width="60%">{{ dataDetail.name }}</td>
                                            <td class="text-center border_header_stock_material_list" width="10%">
                                                {{ dataDetail.max }}/{{ dataDetail.min }}
                                            </td>
                                            <td class="text-center border_header_stock_material_list" width="10%">
                                                {{ dataDetail.unit_name }}
                                            </td>
                                            <td class="text-center border_header_stock_material_list" width="10%">
                                                <span class="cursor_stock_material_list" @click="detailStockMaterial(dataDetail.id)">
                                                    <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                                </span>
                                                <span class="cursor_stock_material_list" @click="confirmDeleteStockMaterial(dataDetail.id,dataDetail.name,dataDetail.status)" v-if="dataDetail.stock <= 0">
                                                    <v-icon dark right color="grey">mdi-delete</v-icon>
                                                </span>
                                                <span class="cursor_stock_material_list" @click="deleteErrorStockMaterial(dataDetail.status)" v-if="dataDetail.stock > 0">
                                                    <v-icon dark right color="grey">mdi-delete</v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </div>
        <!-- เพิ่ม -->
        <v-dialog v-model="open_stock_material_add" persistent>
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">

                <v-card-title class="justify-space-between">
                    <div>
                        เพิ่มวัตถุดิบ
                    </div>
                    <div class="cursor_stock_material_list" @click="open_stock_material_add = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-form ref="form_add" @submit.prevent="addStockMaterial()">
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-img height="330" max-width="280" class="ma-auto" v-if="imagePreviewURL" :src="imagePreviewURL"></v-img>
                                <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="image" label="เพิ่มรูปภาพวัตถุดิบ" @change="onFileChange"></v-file-input>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="ชื่อวัตถุดิบ" v-model="mat_name" color="primary" :rules="[v => !!v || 'กรุณากรอกชื่อวัตถุดิบ']" required outlined></v-text-field>
                                <v-text-field label="Barcode" v-model="barcode" color="primary" outlined></v-text-field>
                                <v-select label="แหล่งที่มา" v-model="mat_source_id" :items="source_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกแหล่งที่มา']" required outlined>
                                </v-select>
                                <v-select label="ประเภท" v-model="mat_type_id" :items="type_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกประเภท']" required outlined>
                                </v-select>
                                <v-autocomplete label="โซน" v-model="outzone_id" :items="zone_list" item-text="id" :rules="[v => v.length > 0 || 'กรุณาเลือกโซน']" required outlined multiple>
                                    <template v-slot:selection="data">
                                        <v-chip color="primary" v-bind="data.attrs" :input-value="data.selected" @click="data.select" close @click:close="removeZone(data.item)">
                                            {{ data.item.zone }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        {{ data.item.zone }}
                                    </template>
                                </v-autocomplete>

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3">
                                <v-text-field label="จำนวน Max" :rules="[v => !!v || 'กรุณากรอกจำนวน Max']" v-model="max" type="tel" @keypress="isNumber($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="จำนวน Min" :rules="[v => !!v || 'กรุณากรอกจำนวน Min']" v-model="min" type="tel" @keypress="isNumber($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="ราคา ขนาดย่อย" :rules="[v => !!v || 'กรุณากรอกราคาขนาดย่อย']" v-model="price" type="number" @keypress="isNumberPrice($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-select label="หน่วยนับ" v-model="unit" :items="unit_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" required outlined>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <h2>ขนาดอื่นๆ</h2>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                <div class="d-flex justify-center align-center">
                                    <h2>1</h2>
                                    <div class="ml-2 default_stock_material_list">
                                        <v-select label="หน่วยนับอื่น" v-model="unit_other_id" :items="unit_list" hide-details="auto" item-text="name" item-value="id" color="primary" outlined>
                                        </v-select>
                                        <div class="d-flex back_default_stock_material_list" v-if="unit_other_id">
                                            <v-icon size="20" @click="unit_other_id = null">mdi-refresh</v-icon>
                                            <div class="ml-1">ย้อนกลับไปค่าเริ่มต้น</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="มีจำนวน" v-model="per_other_unit" hide-details="auto" color="primary" type="tel" @keypress="isNumber($event)" onpaste="return false" outlined></v-text-field>
                            </v-col>

                            <v-col cols="1">
                                <h2 class="d-flex justify-center align-center unit_select_stock_material_list">
                                    {{ unit ? unit_list.find((detail) => { return detail.id == unit }).name : '-' }}
                                </h2>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="ราคา" v-model="price_other" hide-details="auto" color="primary" type="number" @keypress="isNumberPrice($event)" onpaste="return false" outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- แก้ไข -->
        <v-dialog v-model="open_stock_material_edit" persistent>
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">

                <v-card-title class="justify-space-between">
                    <div>
                        แก้ไขวัตถุดิบ
                    </div>
                    <div class="cursor_stock_material_list" @click="open_stock_material_edit = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-form ref="form_edit" @submit.prevent="editStockMaterial()">
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-img height="330" max-width="280" class="ma-auto" v-if="imagePreviewURL" :src="imagePreviewURL"></v-img>
                                <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="image" label="เพิ่มรูปภาพวัตถุดิบ" @change="onFileChange"></v-file-input>

                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="ชื่อวัตถุดิบ" v-model="mat_name" color="primary" :rules="[v => !!v || 'กรุณากรอกชื่อวัตถุดิบ']" required outlined></v-text-field>
                                <v-text-field label="Barcode" v-model="barcode" color="primary" outlined></v-text-field>
                                <v-select label="แหล่งที่มา" v-model="mat_source_id" :items="source_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกแหล่งที่มา']" required outlined>
                                </v-select>
                                <v-select label="ประเภท" v-model="mat_type_id" :items="type_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกประเภท']" required outlined>
                                </v-select>
                                <v-autocomplete label="โซน" v-model="outzone_id" :items="zone_list" item-text="id" :rules="[v => v.length > 0 || 'กรุณาเลือกโซน']" required outlined multiple>
                                    <template v-slot:selection="data">
                                        <v-chip color="primary" v-bind="data.attrs" :input-value="data.selected" @click="data.select" close @click:close="removeZone(data.item)">
                                            {{ data.item.zone }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        {{ data.item.zone }}
                                    </template>
                                </v-autocomplete>

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3">
                                <v-text-field label="จำนวน Max" :rules="[v => !!v || 'กรุณากรอกจำนวน Max']" v-model="max" type="tel" @keypress="isNumber($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="จำนวน Min" :rules="[v => !!v || 'กรุณากรอกจำนวน Min']" v-model="min" type="tel" @keypress="isNumber($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="ราคา ขนาดย่อย" :rules="[v => !!v || 'กรุณากรอกราคาขนาดย่อย']" v-model="price" type="number" @keypress="isNumberPrice($event)" onpaste="return false" color="primary" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-select label="หน่วยนับ" v-model="unit" :items="unit_list" item-text="name" item-value="id" color="primary" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" required outlined>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <h2>ขนาดอื่นๆ</h2>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                <div class="d-flex justify-center align-center">
                                    <h2>1</h2>
                                    <div class="ml-2 default_stock_material_list">
                                        <v-select label="หน่วยนับอื่น" v-model="unit_other_id" :items="unit_list" hide-details="auto" item-text="name" item-value="id" color="primary" outlined>
                                        </v-select>
                                        <div class="d-flex back_default_stock_material_list" v-if="unit_other_id">
                                            <v-icon size="20" @click="unit_other_id = null">mdi-refresh</v-icon>
                                            <div class="ml-1">ย้อนกลับไปค่าเริ่มต้น</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="มีจำนวน" v-model="per_other_unit" hide-details="auto" color="primary" type="tel" @keypress="isNumber($event)" onpaste="return false" outlined></v-text-field>
                            </v-col>

                            <v-col cols="1">
                                <h2 class="d-flex justify-center align-center unit_select_stock_material_list">
                                    {{ unit ? unit_list.find((detail) => { return detail.id == unit }).name : '-' }}
                                </h2>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="ราคา" v-model="price_other" hide-details="auto" color="primary" type="number" @keypress="isNumberPrice($event)" onpaste="return false" outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- ลบ -->
        <v-dialog v-model="open_confirm_delete" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    ต้องการลบวัตถุดิบ {{ name_delete }} ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="deleteStockMaterial()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="cancelDeleteStockMaterial()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import stockmaterial from '@/api/stock/stockmaterial/stockmaterial.js'
import stocktype from '@/api/stock/stocksetting/stocktype.js'
import stocksource from '@/api/stock/stocksetting/stocksource.js'
import stockunit from '@/api/stock/stocksetting/stockunit.js'
import stockzone from '@/api/stock/stocksetting/stockzone.js'
import before_image from "@/assets/seasoning.png";
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            open_confirm_delete: false,
            alert_show_add: false,
            alert_show_edit: false,
            alert_show_delete: false,
            alert_show_error_max_min: false,
            alert_show_error_unit_other:false,
            alert_show_error_delete_stock_material:false,
            message_error_delete_stock_material:'',
            imagePreviewURL: before_image,
            type_list: [],
            source_list: [],
            unit_list: [],
            zone_list: [],
            data: [],
            page_id: null,
            page_key: null,
            source_page_list: [],
            open_stock_material_add: false,
            open_stock_material_edit: false,
            name_delete: null,
            edit_id: null,
            image: null,
            mat_name: null,
            barcode: null,
            mat_source_id: null,
            mat_type_id: null,
            outzone_id: [],
            max: null,
            min: null,
            price: null,
            unit: null,
            per_other_unit: null,
            price_other: null,
            unit_other_id: null,
        }
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async removeZone(item) {
            const index = this.outzone_id.indexOf(item.id)
            if (index >= 0) this.outzone_id.splice(index, 1)
        },
        async stockMaterialList() {
            this.loading_page = true
            this.source_page_list = []
            this.data = []
            this.source_list = []
            this.type_list = []
            this.zone_list = []
            this.unit_list = []

            await stockmaterial.materialList().then((response) => {
                if (response.data.successful === true) {
                    response.data.sources.forEach((detail, index) => {
                        if (index == 0 && !this.page_id) {
                            this.page_id = detail.id
                            this.page_key = 0
                        }
                        this.source_page_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                    })
                    this.data = response.data.sources
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async detailStockMaterialAdd() {
            this.loading_page_detail = true
            this.open_stock_material_add = true
            this.edit_id = null
            this.imagePreviewURL = before_image
            this.image = null
            this.mat_name = null
            this.barcode = null
            this.mat_source_id = null
            this.mat_type_id = null
            this.outzone_id = []
            this.max = null
            this.min = null
            this.price = null
            this.unit = null
            this.per_other_unit = null
            this.price_other = null
            this.unit_other_id = null

            await stocksource.sourceList().then((response) => {
                if (response.data.successful === true) {
                    this.source_list = response.data.sourceList
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stocktype.typeList().then((response) => {
                if (response.data.successful === true) {
                    this.type_list = response.data.material_type
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockzone.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone_list = response.data.zone
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockunit.unitList().then((response) => {
                if (response.data.successful === true) {
                    this.unit_list = response.data.list
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailStockMaterial(id) {
            this.loading_page_detail = true
            this.open_stock_material_edit = true
            this.edit_id = null
            this.imagePreviewURL = before_image
            this.image = null
            this.mat_name = null
            this.barcode = null
            this.mat_source_id = null
            this.mat_type_id = null
            this.outzone_id = []
            this.max = null
            this.min = null
            this.price = null
            this.unit = null
            this.per_other_unit = null
            this.price_other = null
            this.unit_other_id = null
            await stocksource.sourceList().then((response) => {
                if (response.data.successful === true) {
                    this.source_list = response.data.sourceList
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stocktype.typeList().then((response) => {
                if (response.data.successful === true) {
                    this.type_list = response.data.material_type
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockzone.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone_list = response.data.zone
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockunit.unitList().then((response) => {
                if (response.data.successful === true) {
                    this.unit_list = response.data.list

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await stockmaterial.detailMaterial(id).then((response) => {
                if (response.data.successful === true) {
                    this.detail_material = response.data.material
                    this.edit_id = response.data.material.id
                    this.imagePreviewURL = response.data.material.image
                    this.mat_name = response.data.material.name
                    this.barcode = response.data.material.barcode
                    this.mat_source_id = response.data.material.source_id
                    this.mat_type_id = response.data.material.mat_type_id
                    this.outzone_id = response.data.material.outzone_id.map(detail => {
                        return detail.id
                    })
                    this.max = response.data.material.max.toString()
                    this.min = response.data.material.min.toString()
                    this.price = response.data.material.price
                    this.unit = response.data.material.unit_id
                    this.per_other_unit = response.data.material.per_other_unit
                    this.price_other = response.data.material.price_other
                    this.unit_other_id = response.data.material.unit_other_id
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addStockMaterial() {
            if (this.$refs.form_add.validate()) {
                if (parseInt(this.min) > parseInt(this.max)) {
                    this.alert_show_error_max_min = true
                    setTimeout(() => this.alert_show_error_max_min = false, 5000)
                } else if (this.unit == this.unit_other_id) {
                    this.alert_show_error_unit_other = true
                    setTimeout(() => this.alert_show_error_unit_other = false, 5000)
                } else {
                    this.loading_page = true
                    this.open_stock_material_add = false
                    let data = new FormData()
                    data.append('image', this.image)
                    data.append('mat_name', this.mat_name)
                    data.append('barcode', this.barcode)
                    data.append('mat_source_id', this.mat_source_id)
                    data.append('mat_type_id', this.mat_type_id)
                    for (let i = 0; i < this.outzone_id.length; i++) {
                        data.append('outzone_id[]', this.outzone_id[i])
                    }
                    data.append('max', this.max)
                    data.append('min', this.min)
                    data.append('price', this.price)
                    data.append('unit', this.unit)
                    data.append('per_other_unit', this.per_other_unit)
                    if (this.per_other_unit === null || this.per_other_unit === '') {
                        data.delete('per_other_unit')
                    }
                    data.append('price_other', this.price_other)
                    if (this.price_other === null || this.price_other === '') {
                        data.delete('price_other')
                    }
                    data.append('unit_other_id', this.unit_other_id)
                    if (this.unit_other_id === null || this.unit_other_id === '') {
                        data.delete('unit_other_id')
                    }

                    stockmaterial.addMaterial(data).then((response) => {
                        if (response.data.successful === true) {
                            this.stockMaterialList()
                            this.edit_id = null
                            this.imagePreviewURL = before_image
                            this.image = null
                            this.mat_name = null
                            this.barcode = null
                            this.mat_source_id = null
                            this.mat_type_id = null
                            this.outzone_id = []
                            this.max = null
                            this.min = null
                            this.price = null
                            this.unit = null
                            this.per_other_unit = null
                            this.price_other = null
                            this.unit_other_id = null
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
        async editStockMaterial() {
            if (this.$refs.form_edit.validate()) {
                if (parseInt(this.min) > parseInt(this.max)) {
                    this.alert_show_error_max_min = true
                    setTimeout(() => this.alert_show_error_max_min = false, 5000)
                } else if (this.unit == this.unit_other_id) {
                    this.alert_show_error_unit_other = true
                    setTimeout(() => this.alert_show_error_unit_other = false, 5000)
                } else {
                    this.loading_page = true
                    this.open_stock_material_edit = false
                    let data = new FormData()
                    data.append('image', this.image)
                    data.append('mat_name', this.mat_name)
                    data.append('barcode', this.barcode)
                    data.append('mat_source_id', this.mat_source_id)
                    data.append('mat_type_id', this.mat_type_id)
                    for (let i = 0; i < this.outzone_id.length; i++) {
                        data.append('outzone_id[]', this.outzone_id[i])
                    }
                    data.append('max', this.max)
                    data.append('min', this.min)
                    data.append('price', this.price)
                    data.append('unit', this.unit)
                    data.append('per_other_unit', this.per_other_unit)
                    if (this.per_other_unit === null || this.per_other_unit === '') {
                        data.delete('per_other_unit')
                    }
                    data.append('price_other', this.price_other)
                    if (this.price_other === null || this.price_other === '') {
                        data.delete('price_other')
                    }
                    data.append('unit_other_id', this.unit_other_id)
                    if (this.unit_other_id === null || this.unit_other_id === '') {
                        data.delete('unit_other_id')
                    }

                    stockmaterial.editMaterial(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.imagePreviewURL = before_image
                            this.image = null
                            this.mat_name = null
                            this.barcode = null
                            this.mat_source_id = null
                            this.mat_type_id = null
                            this.outzone_id = []
                            this.max = null
                            this.min = null
                            this.price = null
                            this.unit = null
                            this.per_other_unit = null
                            this.price_other = null
                            this.unit_other_id = null
                            this.stockMaterialList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
        async confirmDeleteStockMaterial(id, name,status) {
            if (status == 1) {
                this.message_error_delete_stock_material = 'ขออภัยวัตถุดิบของคุณอยู่ในใบสั่งซื้อที่กำลังดำเนินการ ไม่สามารถลบวัตถุดิบนี้ได้'
                this.alert_show_error_delete_stock_material = true
                setTimeout(() => this.alert_show_error_delete_stock_material = false, 10000)
            }
            if (status != 1) {
                this.open_confirm_delete = true
                this.edit_id = id
                this.name_delete = name
            }
        },
        async cancelDeleteStockMaterial() {
            this.open_confirm_delete = false
            this.edit_id = null
            this.name_delete = null
        },
        async deleteStockMaterial() {
            this.loading_page = true
            this.open_confirm_delete = false
            stockmaterial.deleteMaterial(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = null
                    this.name_delete = null
                    this.stockMaterialList()
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
                else {
                  this.loading_page = false
                  this.message_error_delete_stock_material = response.data.message
                  this.alert_show_error_delete_stock_material = true
                  setTimeout(() => this.alert_show_error_delete_stock_material = false, 10000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async deleteErrorStockMaterial(){
            this.message_error_delete_stock_material = 'ขออภัยวัตถุดิบของท่านยังคงเหลืออยู่ในคลัง กรุณาทำการเบิกออกให้ คงเหลือเป็น 0 ก่อน ถึงจะสามารถลบวัตถุดิบนี้ได้'
            this.alert_show_error_delete_stock_material = true
            setTimeout(() => this.alert_show_error_delete_stock_material = false, 10000)
        },
        async page(id, key) {
            this.page_id = id
            this.page_key = key
        },
    },
    mounted() {
        this.stockMaterialList()
    }

}
</script>

<style scoped>
.color_stock_material_btn {
  background: linear-gradient(to top, #158cba, #55c0e9);
}

.cursor_stock_material_list {
    cursor: pointer;
}

.border_header_stock_material_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.default_stock_material_list {
    position: relative;
}

.back_default_stock_material_list {
    position: absolute;
    bottom: -25px;
}

.unit_select_stock_material_list {
    height: 100%;
}

</style>
